/* eslint-disable import/no-unresolved */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@material-ui/lab';
import { Box, Card, Grid, Stack, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { updateExclusionParentRule } from 'src/redux/slices/exclusionrules';

ExclusionRuleSetForm.propTypes = {
  editId: PropTypes.object,
  handleClose: PropTypes.func,
  parentRuleId: PropTypes.number
};

export default function ExclusionRuleSetForm({ editId, handleClose }) {
  const dispatch = useDispatch();

  const NewUserSchema = Yup.object().shape({
    parentRuleName: Yup.mixed().required('*Required')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      parentRuleName: editId ? editId.name : '',
      status: editId ? editId.status : false
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const exclusionParentRuleData = {
          exclusion_rule_name: values.parentRuleName
          // active: values.status
        };
        setSubmitting(false);

        if (editId) {
          dispatch(updateExclusionParentRule(exclusionParentRuleData, editId?.parentRuleId));
        } else {
          // dispatch(createNewExclusionRule(exclusionParentRuleData, editId.parentRuleId));
        }
        handleClose();
      } catch (error) {
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, handleChange } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Card sx={{ p: 3 }}>
          <Stack spacing={2}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
              <TextField
                fullWidth
                name="parentRuleName"
                label="Exclusion Rule Name"
                value={values.parentRuleName}
                onChange={handleChange}
                error={Boolean(touched.parentRuleName && errors.parentRuleName)}
                helperText={touched.parentRuleName && errors.parentRuleName}
              />
            </Stack>
          </Stack>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Stack spacing={3}>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton sx={{ marginRight: '1rem' }} type="button" variant="outlined" onClick={handleClose}>
                    Cancel
                  </LoadingButton>
                  <LoadingButton sx={{ marginRight: '1rem' }} type="submit" variant="contained" loading={isSubmitting}>
                    {!editId ? 'Save' : 'Update'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Card>
      </Form>
    </FormikProvider>
  );
}
